import React from 'react';
import HkModalHeader from 'components/modal/HkModalHeader';
import './HkModal.scss';

interface HkModalContentProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Shared header/content shell (Figma modal frames: white header with title +
 * close icon, white content) — the presentational piece behind both
 * `HkModal` (owns its own IonModal, for standalone modals like
 * delete-confirm) and any content embedded inside an already-open IonModal
 * owned by a parent (e.g. the Add Item landing step, which shares
 * InventoryAddProduct's outer modal with the manual-add step that follows
 * it — nesting a second IonModal there would be wrong).
 *
 * Footer is NOT this component's concern — `HkModal` renders it directly
 * (as an `IonFooter`/`IonToolbar`, a true sibling of this content, not
 * nested inside it) so it stays visually pinned rather than being treated
 * as part of the content region.
 */
const HkModalContent: React.FC<HkModalContentProps> = ({
  title,
  onClose,
  children
}) => {
  return (
    <>
      <HkModalHeader title={title} onClose={onClose} />
      <div className="hk-modal-content">{children}</div>
    </>
  );
};

export default HkModalContent;
